<template>
    <div role="listitem" :class="[message.isAuthor ? 'user-message' : 'participant-message']" class="message">
        <div class="group flex flex-initial flex-col space-y-1">
            <div :class="[message.isAuthor ? 'flex-row-reverse space-x-reverse' : 'flex-row']" class="flex items-end space-x-2">
                <div>
                    <avatar :user="message.author" class="w-9 h-9"></avatar>
                </div>
                <div :class="[message.isAuthor ? 'bg-indigo-500 text-white' : 'bg-gray-200 text-gray-800']" class="relative flex flex-col px-3 py-2 text-sm rounded-lg shadow-sm divide-gray-300 divide-y space-y-2 sm:px-4 sm:rounded-xl">
                    <!--<div v-html="message.html" />-->
                    <component :is="message.template" :message="message" />
                </div>
            </div>
            <div :class="[message.isAuthor ? 'pr-12 flex-row-reverse' : 'pl-12 flex-row']" class="hidden justify-end text-gray-400 text-xs font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-100 ease-in-out md:flex">
                <time :datetime="message.createdAt">{{ message.createdAt | datetime }}</time>
            </div>
        </div>
        <div class="md:w-3/5"></div>
    </div>
</template>

<script>
import JetButton from "@/Jetstream/Button"
import LinkButton from "@/Components/Buttons/LinkButton"

export default {
    components: {
        LinkButton,
        JetButton,
        ChallengeRequested: () => import("@/Pages/Messenger/Templates/ChallengeRequested"),
        Default: () => import("@/Pages/Messenger/Templates/Default"),
    },

    props: {
        message: {
            required: true,
            type: Object,
        },
    },
}
</script>
